import { useState, useEffect } from "react";

const useMediaQueries = () => {
    const [currentBP, setBreakpoint] = useState("xl");

    let checkScreenSize = () => {
        let width = window.innerWidth;
        if (width <= 420) {
            setBreakpoint("xs");
        } else if (width > 420 && width <= 767) {
            setBreakpoint("sm");
        } else if (width > 767 && width <= 1023) {
            setBreakpoint("md");
        } else if (width > 1023 && width <= 1365) {
            setBreakpoint("lg");
        } else if (width > 1365) {
            setBreakpoint("xl");
        }
    };
    useEffect(() => {
        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);

        return () => window.removeEventListener("resize", checkScreenSize);
    }, []);

    return currentBP;
};

export default useMediaQueries;
